import { CoreCustomersByIdUsersName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getCustomerUsers } from '@api';
import { updateUserReferences } from '../../../users/_idMap/actions';

export const coreCustomersByIdUsersGetSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(response) =>
				updateUserReferences(
					response.results.map((user) => ({
						email: user.email,
						firstName: user.firstName,
						fullName: user.fullName,
						isLocked: user.isLocked,
						isReadOnly: user.isReadOnly,
						lastName: user.lastName,
						userId: user.id
					}))
				)
		]
	},
	name: CoreCustomersByIdUsersName,
	receive: true,
	request: true,
	requestHandler: getCustomerUsers,
	retainDataOnRequest: true
});
